import { fetchEndpointData } from '@/utils/fetch.client';

export interface SubmitBetaRequestPayload {
  email: string;
  name: string;
  job_title?: string;
  company?: string;
  heard_from?: string;
}

export async function submitBetaRequest(payload: SubmitBetaRequestPayload) {
  return fetchEndpointData<{ ok: boolean }>('/api/v1/auth/beta-request', {
    method: 'POST',
    body: payload,
  });
}
